import React from 'react';
import {
  Button,
  Col,
  Row,
  Table
} from 'react-bootstrap';
import { Link } from 'react-router';
import PageHeader from '../Layout/PageHeader';

import Loading from '../Loading';
import Address from '../../util/Address';
import IpUtil from '../../util/Ip';

function copyToClipboard(elem) {
  let origSelectionStart, origSelectionEnd;
  // can just use the original source element for the selection and copy
  const target = elem;
  origSelectionStart = elem.selectionStart;
  origSelectionEnd = elem.selectionEnd;
  // select the content
  const currentFocus = document.activeElement;
  target.focus();
  target.setSelectionRange(0, target.value.length);

  // copy the selection
  let succeed;
  try {
    succeed = document.execCommand("copy");
  } catch(e) {
    succeed = false;
  }
  // restore original focus
  if (currentFocus && typeof currentFocus.focus === "function") {
    currentFocus.focus();
  }

  // restore prior selection
  elem.setSelectionRange(origSelectionStart, origSelectionEnd);

  return succeed;
}

const Dashboard = React.createClass({
  render: function () {
    return <section id="dashboard">
      <PageHeader><h1>Partner Portal</h1></PageHeader>

      <Button className="pull-right" bsStyle="primary" href={_SIGNUP_BASE + '/partner'} target="_blank">Sign up Customers</Button>

      <Row>
        <Col lg={10}>
          {this.props.loading && <Loading />}
          {!this.props.loading &&
            this.props.partners.map(p => {
              const url = `${location.origin}/auth?partner=${p.authHash}`
              return (
                <div key={p.id}>
                    <h2>{p.name}</h2>

                    <Table className="table-hover table-bordered">
                        <thead><tr>
                            <th colSpan={2}>Service</th>
                            <th>Site</th>
                        </tr></thead>
                        {p.relationships.length === 0 && (
                            <tbody><tr>
                                <td colSpan={5}>
                                  <p>
                                    Welcome to the Infinite partner portal. There are no clients currently linked to your
                                    partner account.
                                  </p>
                                </td>
                            </tr></tbody>
                        )}
                        {p.relationships.map(rel => (
                            <tbody key={rel.client_id}>
                                <tr>
                                    <td colSpan={5}><h4>{rel.client.name}</h4></td>
                                </tr>
                                {!this.props.services[rel.client_id] && (
                                    <tr>
                                        <td colSpan={5}>
                                            No services available.
                                        </td>
                                    </tr>
                                )}
                                {this.props.services[rel.client_id] && this.props.services[rel.client_id].map(service => (
                                    <tr key={service.id}>
                                        <td>
                                            {service.reference}<br />
                                            {service.customerReference && (
                                                <small className="text-muted">{service.customerReference}</small>
                                            )}
                                        </td>
                                        <td>
                                            <h5>{service.service.name}</h5>
                                            {service.site.name}<br />
                                            {Address.autoFormat(service.site)}
                                        </td>
                                        <td>
                                            <strong>
                                                <Link to="partner-service" params={{
                                                    serviceId: service.id,
                                                    clientId: rel.client_id,
                                                }}>
                                                    {IpUtil.format(service.identifier, true)}
                                                </Link>
                                            </strong>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        ))}
                    </Table>
                    <Row><Col lg={8} lgOffset={2}>
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <h4>Adding a client</h4>
                                <p>
                                    To add a client please send your client the following link. Once
                                    the client completes the authorisation form by logging into their account with the
                                    correct email and password you will have technical access to their services.
                                </p>
                                <div className="form-group">
                                    <span className="input-group">
                                        <input
                                            readOnly
                                            type="text"
                                            value={url}
                                            className="form-control"
                                            ref={"partner-url-" + p.id}
                                        />
                                        <span className="input-group-btn">
                                            <button type="button" onClick={() => copyToClipboard(this.refs['partner-url-' + p.id].getDOMNode())} className="btn btn-default">Copy</button>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col></Row>
                </div>
              )
            })}
        </Col>
      </Row>
    </section>;
  }
});

module.exports = Dashboard;



// WEBPACK FOOTER //
// ./app/components/Partner/Dashboard.js